import type {
  DayOfWeek,
  EducationClass,
  ScheduleErrorTimeslot,
  ScheduleLesson,
} from 'services/api';

type GridCell = {
  slotKey: string;
  day: DayOfWeek;
  startTime: string;
  endTime: string;
  isError: boolean;
  educationalClass: EducationClass;
  item?: ScheduleLesson[];
  category?: 'LOGICAL' | 'SANPIN';
  errors?: ScheduleErrorTimeslot[];
  isSuggested?: boolean;
};

interface GetSuggestedDropSlotKeys {
  gridRows: {
    key: string;
    day: DayOfWeek;
    startTime: string;
    endTime: string;
    isFirstLessonInDay: boolean;
    isLastLessonInDay: boolean;
    isLastDay: boolean;
    cells: GridCell[];
  }[];
  sourceSlotKey: string;
  lessonId: number;
  lessonBySlot: Record<string, ScheduleLesson[]>;
}

const getTimeKey = (cell: GridCell) => `${cell.day}-${cell.startTime}-${cell.endTime}`;

export const getSuggestedDropSlotKeys = ({
  gridRows,
  sourceSlotKey,
  lessonId,
  lessonBySlot,
}: GetSuggestedDropSlotKeys) => {
  if (!sourceSlotKey || !lessonId) {
    return [];
  }

  const [, , , sourceClassId] = sourceSlotKey.split('-');
  const draggedLesson = lessonBySlot[sourceSlotKey]?.find((lesson) => lesson.id === lessonId);

  if (!draggedLesson) {
    return [];
  }

  const allCells = gridRows.flatMap((row) => row.cells);

  const busyTimeKeys = new Set<string>();

  allCells.forEach((cell) => {
    if (!cell.item?.length) {
      return;
    }

    const isTeacherOrRoomConflict = cell.item.some(
      (lesson) =>
        lesson.teacher.id === draggedLesson.teacher.id || lesson.room.id === draggedLesson.room.id,
    );

    if (isTeacherOrRoomConflict) {
      busyTimeKeys.add(getTimeKey(cell));
    }
  });

  const candidates = allCells.filter(
    (cell) =>
      cell.educationalClass.id === Number(sourceClassId) &&
      cell.slotKey !== sourceSlotKey &&
      !cell.item?.length,
  );

  return candidates
    .filter((cell) => !busyTimeKeys.has(getTimeKey(cell)))
    .map((cell) => cell.slotKey);
};
